import throttle from "just-throttle";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import OverlayMenu from "@lib/beskar-overlay-menu/bskr-overlay-menu.mjs";

// Get current value of --wp-admin--admin-bar--height css variable and store it in a variable
// Variable --wp-admin--admin-bar--position-offset is locked by specificity so we use
const adminBarOffset = parseInt(
  getComputedStyle(document.documentElement).getPropertyValue(
    "--wp-admin--admin-bar--height"
  )
);

function updateAdminBarOffset(visible) {
  const header = document.getElementById("header");
  const fixedElement = document.querySelector(".is-position-sticky");

  if (fixedElement) {
    // If the header is visible then set the value of --wp-admin--admin-bar--position-offset css variable to the header offsetHeight plus adminBarOffset

    if (visible) {
      fixedElement.style.setProperty(
        "--wac--header-height",
        header.offsetHeight + "px"
      );
    } else {
      // return the value of --wp-admin--admin-bar--position-offset css variable into --wp-admin--admin-bar--position-offset--initial value
      fixedElement.style.setProperty("--wac--header-height", 0 + "px");
    }
  }
}

function initLenisScroll() {
  const lenis = new Lenis({
    prevent: function (element) {
      return element.classList.contains("no-lenis");
    },
  });
  window.lenisInstance = lenis;

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  return { lenis, addEventListener, gsapTicker: gsap.ticker };
}

let isHeaderHidden = false;

function toggleHeaderOnMenu(
  header,
  args = { duration: 0.5, ease: "power4.out" }
) {
  document.body.classList.toggle("on-menu-opened");
  const isHidden = toggleHeader(header, args);
  gsap.to(header, {
    yPercent: isHidden ? -100 : 0,
    ...args,
  });
}

function showHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  gsap.to(header, {
    yPercent: 0,
    ...args,
  });
}

function hideHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  gsap.to(header, {
    yPercent: -100,
    ...args,
  });
}

function toggleHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  isHeaderHidden = !isHeaderHidden;
  !isHeaderHidden ? hideHeader(header, args) : showHeader(header, args);
  return isHeaderHidden;
}

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(gsap.ScrollTrigger);

  const isDesktop = window.innerWidth >= 1024;

  let lenis = isDesktop ? initLenisScroll().lenis : null;

  const header = document.getElementById("header");
  const overlayMenu = new OverlayMenu("main", { options: { duration: 1 } });

  if (overlayMenu) {
    // Suscribirse a eventos con el nuevo método
    overlayMenu.addEvent(
      "onOpen",
      throttle(() => {
        lenis?.stop();
        toggleHeaderOnMenu(header);
      }, 10)
    );

    overlayMenu.addEvent(
      "onClosed",
      throttle(() => {
        lenis?.start();
        toggleHeaderOnMenu(header);
      }, 10)
    );
  }

  window.showHeader = () => showHeader(header);
  window.hideHeader = () => hideHeader(header);
  window.toggleHeader = () => toggleHeader(header);

  // Language Selector

  const langSelector = document.querySelectorAll(".language-selector");

  if (langSelector) {
    langSelector.forEach((selector) => {
      selector.addEventListener("change", function () {
        window.location.href = this.value;
      });
    });
  }

  // Multisite Selector
  const multisiteSelector = document.querySelectorAll(".multisite-selector");

  multisiteSelector.forEach((selector) => {
    const trigger = selector.querySelector(".button");
    const dropdown = selector.querySelector(".dropdown");

    selector.addEventListener("click", () => {
      // Toggle class
      dropdown.classList.toggle("show");

      if (!dropdown.classList.contains("show")) return;

      // Reset positioning
      dropdown.style.top = "";
      dropdown.style.bottom = "";
      dropdown.style.maxHeight = "";
      dropdown.style.overflowY = "";

      // Get measurements
      const triggerRect = trigger.getBoundingClientRect();
      const dropdownHeight = dropdown.scrollHeight;
      const offset = 4;
      const triggerHeight = trigger.offsetHeight + offset;
      const spaceBelow = window.innerHeight - triggerRect.bottom;
      const spaceAbove = triggerRect.top;

      if (spaceBelow >= dropdownHeight + triggerHeight) {
        dropdown.style.top = `${triggerHeight}px`;
      } else if (spaceAbove >= dropdownHeight + triggerHeight) {
        dropdown.style.bottom = `${triggerHeight}px`;
      } else {
        dropdown.style.bottom = `${triggerHeight}px`;
        dropdown.style.overflowY = "auto";
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // If development, log a message to the console
  if (process.env.NODE_ENV === "development") {
    console.log("✨ Welcome to Beskar Theme ✨ Development mode enabled.");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const visitUsForm = document.querySelector(".visit-us__form");

  if (!visitUsForm) return;

  const singleVisit = document.querySelector(".single-visit");
  const visitUsField = visitUsForm.querySelector("[name='visit-us']");
  const requestedVisit = document.getElementById("requested-visit");

  function getSlugFromURL() {
    const path = window.location.pathname;
    const parts = path.split("/").filter(Boolean);
    return parts[parts.length - 1];
  }

  function handleSingleVisit() {
    const slug = getSlugFromURL();
    visitUsField.value = slug;
    visitUsField.style.pointerEvents = "none";
    visitUsField.tabIndex = -1;
    requestedVisit.value = slug;
  }

  function handleVisitSelect() {
    visitUsField.addEventListener("change", function () {
      requestedVisit.value = visitUsField.value;
    });
  }

  function cloneAndHideSendButton() {
    const sendButton = document.getElementById("send-btn");
    if (!sendButton) return;
    const sendButtonCopy = sendButton.cloneNode(true);
    const wrapper = visitUsForm.querySelector(".cf7mls-btns-last-step");
    if (wrapper) {
      wrapper.appendChild(sendButtonCopy);
      sendButtonCopy.style.opacity = "0";
      sendButtonCopy.style.pointerEvents = "none";
    }
  }

  function setupProgressBars() {
    const steps = visitUsForm.querySelectorAll(".fieldset-cf7mls");
    const totalSteps = steps.length;
    steps.forEach((step, index) => {
      const progressBar = step.querySelector(".progress-bar div");
      if (progressBar) {
        const percent = ((index + 1) / totalSteps) * 100;
        progressBar.style.width = `${percent}%`;
      }
    });
  }

  function setupCustomSpinners() {
    const spinners = document.querySelectorAll(".custom-spinner");

    spinners.forEach((spinner) => {
      const input = spinner.querySelector('input[type="number"]');
      const up = spinner.querySelector(".up");
      const down = spinner.querySelector(".down");

      if (!input || !up || !down) return;

      up.addEventListener("click", () => {
        const max = parseInt(input.max || 99, 10);
        const value = parseInt(input.value || 0, 10);
        if (value < max) input.value = value + 1;
      });

      down.addEventListener("click", () => {
        const min = parseInt(input.min || 0, 10);
        const value = parseInt(input.value || 0, 10);
        if (value > min) input.value = value - 1;
      });
    });
  }

  if (singleVisit) {
    handleSingleVisit();
  } else if (visitUsField && requestedVisit) {
    handleVisitSelect();
  }

  cloneAndHideSendButton();
  setupProgressBars();
  setupCustomSpinners();

  document.addEventListener("wpcf7mailsent", function (event) {
    const formWrapper = document.querySelector("#form");

    fetch(my_ajax_object.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "load_visit_us_thankyou",
        nonce: my_ajax_object.nonce,
      }),
    })
      .then((response) => response.text())
      .then((html) => {
        formWrapper.insertAdjacentHTML("beforeend", html);
      })
      .catch((error) => {
        console.error("Error al cargar el template:", error);
      });
  });

  document.addEventListener("click", (event) => {
    const closeButton = event.target.closest("[data-close]");
    if (closeButton) {
      const modal = document.querySelector(".visit-us-thank-you");
      if (modal) {
        document.querySelector(".wpcf7-response-output").innerHTML = "";
        modal.remove();
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("age-check-modal");
  const acceptBtn = document.getElementById("age-check-accept");
  const closeBtn = document.getElementById("age-check-close");
  const declineBtn = document.getElementById("age-check-decline");
  const ageVerified = document.cookie
    .split("; ")
    .find((row) => row.startsWith("age_verified="));
  const goBackFn = () => {
    window.history.back();
  };

  let ageVerifiedEvent = null;

  ageVerifiedEvent = new CustomEvent("onAgeVerified", {
    detail: { accepted: true },
  });

  if (modal && !ageVerified) {
    modal.style.display = "flex";
    let bodyOverflowStatus = document.body.style.overflow;
    window.document.body.style.overflow = "hidden";

    acceptBtn.addEventListener("click", function () {
      // Set cookie for 30 days
      window.document.cookie =
        "age_verified=true; path=/; max-age=" + 60 * 60 * 24 * 30;
      window.document.body.style.overflow = bodyOverflowStatus;
      window.document.dispatchEvent(ageVerifiedEvent);
      modal.remove();
    });

    closeBtn.addEventListener("click", goBackFn);
    declineBtn.addEventListener("click", goBackFn);
  } else if (ageVerified) {
    // HACK: If the cookie exists, dispatch the event immediately
    setTimeout(() => {
      window.document.dispatchEvent(ageVerifiedEvent);
    }, 1);
  }
});
